/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};

GS.Filters.SVGElements=new Class({
    Extends: GS.BaseClass,
    class_name:'GS.Filters.SVGElements',
    options:{
        //tags:['defs','filter','feOffset','feColorMatrix','feGaussianBlur','feMerge','feMergeNode','pattern','pattern_image','rect'],
        tags:['defs',
              'filter',
              'feOffset',
              'feFlood',
              'feImage',
              'feColorMatrix',
              'feGaussianBlur',
              'feMerge',
              'feMergeNode',
              'feFuncR',
              'feFuncG',
              'feFuncB',
              'feBlend',
              'feComponentTransfer',
              'linearGradient',
              'path',
              'pattern',
              'pattern_image',
              'rect',
              'stop',
               'hue',
                'text',
              'foreignObject']
    },
    //ids:[],
    ids:{
        'masks' : [],
        'thumbnails':[],
        'filters':[],
        'patterns' : [],
        'gradients' : []
    },
    initialize:function(conf, observer){
        this.parent(conf, observer);
        this.extendNetiveElements();
        //console.debug('REGISTERED');
        //this.register('generate:uid',this.generateFilterUID.bind(this));
        this.register('filter:uid',this.generateFilterUID.bind(this));
        this.register('pattern:uid',this.generatePatternUID.bind(this));
        this.register('mask:uid',this.generateMaskUID.bind(this));
        this.register('spread:new',this.resetFiltersUIDs.bind(this));
        this.register('gradients:uid',this.generateGradientUID.bind(this));
    }
});

/**
 * 
 * @returns {void}
 */
GS.Filters.SVGElements.prototype.extendNetiveElements=function(){
    var self=this;
    Array.each(this.options.tags,function(tag,i){
        Element.Constructors[tag]=function(prop){
            if(tag==='pattern_image') tag='image';
            var ele = document.createElementNS("http://www.w3.org/2000/svg", tag);
            if(!prop) prop = {};
            Object.each(prop,function(v,p){
               //console.info(ele, v, p);
               if((tag==='image' || tag==='feImage') && p==='href'){
                    ele.setAttributeNS('http://www.w3.org/1999/xlink','href', v);
                }else{
                    ele.setAttribute(p,v);
                }
               
            });
            return ele;
        };
    });
    
    //Extend Events with drag and drop ones
    Element.NativeEvents = Object.append(Element.NativeEvents, {
        dragenter: 2, dragover: 2, drop: 2, dragleave: 2
    });
    //this.console.warn('Support for drag and drop events enabled!');
    //this.console.warn('Native Mootools Element sucessfully extendeds with SVG Filters: "%s" !',this.options.tags+'');
    //this.console.warn('From now on simply use "var filter=new Element(\'filter\',[options]));"');
};

/**
 * Generate Filter UID
 * @param {function} callback
 * @returns {string} nID;
 */
GS.Filters.SVGElements.prototype.generateMaskUID=function(callback){
   // var use = (this.options.thumbnail) : 'thumbnails', 'filters', 'masks';

    var nID='MUID_'+this.ids.masks.length;
    this.ids.masks.push(nID);
    callback(nID);
    //console.log('Generated new UID "%s"',this.ids.masks.length);
    return nID;
};

GS.Filters.SVGElements.prototype.generateGradientUID=function(callback){
    // var use = (this.options.thumbnail) : 'thumbnails', 'filters', 'masks';

    var nID='GUID_'+this.ids.gradients.length;
    this.ids.gradients.push(nID);
    callback(nID);
    return nID;
};

/**
 * Generate Filter UID
 * @param {function} callback
 * @returns {string} nID;
 */
GS.Filters.SVGElements.prototype.generateFilterUID=function(callback){
    var nID='FUID_'+this.ids.filters.length;
    this.ids.filters.push(nID);
    callback(nID);
    //this.console.log('Generated new UID "%s"',nID);
    return nID;
};

/**
 * Generate Pattern UID
 * @param {function} callback
 * @returns {string} nID;
 */
GS.Filters.SVGElements.prototype.generatePatternUID=function(callback){
    //if(!this.ids[type]) this.ids[type]=[];
    //var nID=type+'_UID_'+this.ids[type].length;
    var nID='PUID_'+this.ids.patterns.length;
    this.ids.patterns.push(nID);
    
    callback(nID);
    return nID;
};

/**
 * 
 * @returns {void}
 */
GS.Filters.SVGElements.prototype.resetFiltersUIDs=function(){
    //this.ids=[];
    this.ids = {
        'masks' : [],
        'thumbnails':[],
        'filters':[],
        'patterns' : [],
        'gradients' :[]
    };
};